import './notification.scss';

import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import NotificationContainer from './notification';

export default (props) => {
	return (
		<ReactCSSTransitionGroup component="div" className="notification-panel" transitionName="list-item-anim" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
		{props.notifications.map((notif) => {
			return (
				<NotificationContainer key={notif.id} data={notif} />
			);
		})}
		</ReactCSSTransitionGroup>
	);
}



/** WEBPACK FOOTER **
 ** ./components/notification/panel.js
 **/